import Lily1 from '../Launching/Lily (1).webp'
import Lily2 from '../Launching/Lily (2).webp'


const Lilyimages =[
Lily1,Lily2
]

export default Lilyimages;